export const modals = {
  exit: {
    title: "Discard Changes",
    description: "Changes will not be saved. Do you want to proceed?",
  },
  delete: {
    title: "Are you sure?",
    description: "This will delete this vehicle type permanently. You cannot undo this action, do you wish to continue?",
  },
  deleteErrorVehicles: {
    title: "Unable to remove vehicle type",
    description:
      "This vehicle type is currently linked to one or more vehicles. Please remove or reassign those vehicles first before deleting this vehicle type.",
  },
  deleteErrorOpenJobs: {
    title: "Unable to remove vehicle type",
    description:
      "This vehicle type is currently linked to one or more open jobs. Please complete or reassign those jobs first before deleting this vehicle type.",
  },
  error: {
    title: "Unable to do this action",
    description: "",
  },
};
